module.exports = __webpack_public_path__ + "static/media/waterfowl@2x.07c9f480.jpg";